import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { environment } from 'src/environments/environment';
let getFacilityListingApi = environment.base_url + 'user/get_all';
// let downloadFacilityCSVApi = environment.base_url + 'user/csv';
let getCSEListingApi = environment.base_url + 'master/cse/get_all';
// let downloadCSEcsvApi = environment.base_url + 'master/cse/csv';
let createCSEApi = environment.base_url + 'master/cse/create';
let updateCSEApi = environment.base_url + 'master/cse/create';     // API is same, just add userId in params
let mapCseFacilityApi = environment.base_url + 'user/map_cse';     // API is same, just add userId in params
// let updateCseFacilityApi = environment.base_url + 'user/change_map';     // API is same, just add userId in params
let getMapListingApi = environment.base_url + 'master/cse/map_list';     // API is same, just add userId in params
// let downloadMappedCsvApi = environment.base_url + 'master/cse/map_csv';     // API is same, just add userId in params
let mappedCseFacilityApi = environment.base_url + 'user/map_cse_facility';     // API is same, just add userId in params
let paymentUpdateApi = environment.base_url + 'payment/update';     // API is same, just add userId in params
let dashboardOperationApi = environment.base_url + 'dashboard/operation'; 
let stateRegisteredFacilities=environment.base_url + 'user/census-wise-count?type=state'
let districtRegisteredFacilities=environment.base_url + 'user/census-wise-count?type=district'
let facilitiesBedSize=environment.base_url + 'dashboard/facility-by-bed-size';
let facilitiesRegisteredbyMonth=environment.base_url + 'dashboard/facility-by-month'
let QiTrainingQaCertification ='https://jsonplaceholder.typicode.com/todos'

@Injectable({
  providedIn: 'root'
})

export class AdminService {
  showLoader = new BehaviorSubject<Boolean>(false);
  mapFilter: BehaviorSubject<any> = new BehaviorSubject(false);

  mapReset = this.mapFilter.asObservable();
  districtBoundaries: any;
  stateBoundaries: any;
  
  constructor(private http: HttpClient) { }

  getFacilityListing(params, token) {
    return this.http.get(`${getFacilityListingApi}?${params}`, { headers: { 'x-access-token': token } });
  }

  // downloadFacilityCSV(params, token) {
  //   return this.http.get(`${downloadFacilityCSVApi}?${params}&token=${token}`, { responseType: 'text' });
  // }

  getCSEListing(params, token) {
    return this.http.get(`${getCSEListingApi}?${params}`, { headers: { 'x-access-token': token } });
  }

  createCSE(body, token) {
    return this.http.post(`${createCSEApi}`, body, { headers: { 'x-access-token': token } });
  }

  updateCSE(userId, body, token) {
    return this.http.post(`${updateCSEApi}?id=${userId}`, body, { headers: { 'x-access-token': token } })
  }

  // downloadCSECSV(params, token) {
  //   return this.http.get(`${downloadCSEcsvApi}?${params}&token=${token}`, { responseType: 'text' });
  // }

  mapCseFacility(body, token) {
    return this.http.put(`${mapCseFacilityApi}`, body, { headers: { 'x-access-token': token } })
  }

  // updateCseFacility(body, token){
  //   return this.http.put(`${updateCseFacilityApi}`, body, { headers: { 'x-access-token': token } })
  // }

  getMapListing(params, token) {
    return this.http.get(`${getMapListingApi}?${params}`, { headers: { 'x-access-token': token } });
  }

  // downloadMappedCSV(params, token) {
  //   return this.http.get(`${downloadMappedCsvApi}?${params}&token=${token}`, { responseType: 'text' });
  // }

  mappedCseFacility(id, params, token) {
    return this.http.get(`${mappedCseFacilityApi}/${id}?${params}`, { headers: { 'x-access-token': token } });
  }

  paymentUpdate(payload) {
    return this.http.put(`${paymentUpdateApi}`, payload, { headers: { 'x-access-token': sessionStorage.getItem('token') } });
  }

  adminDashboardOperation(params) {
    return this.http.get(`${dashboardOperationApi}?${params}`, { headers: { 'x-access-token': sessionStorage.getItem('token') } });
  }

  downloadCSV(apiEndpoint,params,token) {
    return this.http.get(environment.base_url + `${apiEndpoint}?${params}&token=${token}`, { responseType: 'text' });
  }
  stateRegisteredFacilitiesListing(params,token) {
    return this.http.get(`${stateRegisteredFacilities}&${params}`, { headers: { 'x-access-token': token } });
  }
  facilitiesBedSizeListing(params,token) {
    return this.http.get(`${facilitiesBedSize}?${params}`, { headers: { 'x-access-token': token } });
  }
  facilitiesRegisteredbyMonthListing(params,token) {
    return this.http.get(`${facilitiesRegisteredbyMonth}?${params}`, { headers: { 'x-access-token': token } });
  }
  QiTrainingQaCertification(){
    return this.http.get(`${QiTrainingQaCertification}`);
  }


  createCsv(result, fileName) {
    let blob: Blob = new Blob([result], { type: 'text/csv;charset=utf-8;' });
    let url: string = URL.createObjectURL(blob);
    this.autoDownload(url, fileName);
  }

  autoDownload(url: string, file: string) {
    let element: HTMLAnchorElement = document.createElement('a');
    element.href = url;
    element.target = '_blank';
    element.download = file;
    element.click();
    document.body.removeChild(element);
  }

  districtRegisteredFacilitiesListing(params, token) {
    return this.http.get(`${districtRegisteredFacilities}&${params}`, { headers: { 'x-access-token': token } });
  }


  //leaflet map api
  async getStatesGeoJson(){

    if(!this.districtBoundaries){

        const districtResponse = await fetch('../../../assets/Const_Json/districts_boundaries.json');

        this.districtBoundaries = await districtResponse.json();

    }

    if(!this.stateBoundaries){

        const stateResponse = await fetch('../../../assets/Const_Json/state_boundaries.json');

        this.stateBoundaries = await stateResponse.json();
     
    }

    return Promise.resolve({districtBoundaries:this.districtBoundaries, stateBoundaries:this.stateBoundaries});

}
updateMapreset(){

  this.mapFilter.next(true);

}
  
}
